import fetchServer from "../fetchServer";

export default async function createAccount(data, cancelToken) {
  let result = { return: 0, msg: "Something went wrong logging user!" };

  await fetchServer({
    method: "POST",
    url: `/account`,
    data,
    cancelToken,
  })
    .then((res) => {
      if (res?.status === 200) {
        result = { return: 1, msg: "Welcome", data: res.data };
      } else {
        result["msg"] = res?.data?.error || result["msg"];
        result["data"] = res?.data;
      }
    })
    .catch((err) => {
      result["msg"] = err.message;
    });
  return result;
}
